import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            offTime : '+09:00',
            //발송 구분
            type : 1,
            title : '',
            content : '',
            //예약 여부
            reservation : 0,
            //예약 발송날짜
            reservationDate : new Date(),
            //거주 국가 키값
            residenceCountry: [],
            //구사가능한언어
            spoken : [],
            //학습언어 키값
            study : [],
            //거주 국가 시간대 키값
            time : [],
            //국가 키값
            country: [],
            //성별
            gender : null,
            //현지시간
            localTime : null,
            titleScheduler: '',
            contentScheduler: ''
        }
    },
    validators: {
        title: function (value) {
            return Validator.value(value)
                .required('내용을 입력해 주세요.')
                .custom(() => {
                    let koreanRegex = /[ㄱ-ㅎㅏ-ㅣ가-힣]/;
                    let match = value.match(koreanRegex);
                    if (match) {
                        return '푸시 제목은 영문만 입력이 가능합니다.';
                    }
                })
        },
        titleScheduler: function (value) {
            return Validator.value(value)
                .required('내용을 입력해 주세요.')
        },
        content: function (value) {
            return Validator.value(value)
                .required('내용을 입력해 주세요.')
                .custom(() => {
                    let koreanRegex = /[ㄱ-ㅎㅏ-ㅣ가-힣]/;
                    let match = value.match(koreanRegex);
                    if (match) {
                        return '내용은 영문만 입력이 가능합니다.';
                    }
                })
        },
        contentScheduler: function (value) {
            return Validator.value(value)
                .required('내용을 입력해 주세요.')
        },
        type: function (value){
            return Validator.value(value)
                .required('발송 구분을 선택해 주세요.')
        },
        reservation: function (value) {
            return Validator.value(value)
                .required('예약 발송 여부를 입력해 주세요.')
        },
        reservationDate: function (value) {
            return Validator.value(value)
                .required('예약 날짜를 선택해주세요.')
        },
        residenceCountry: function (value) {
            return Validator.value(value)
        },
        spoken: function (value) {
            return Validator.value(value)
        },
        study: function (value) {
            return Validator.value(value)
        },
        time: function (value) {
            return Validator.value(value)
        },
        country: function (value) {
            return Validator.value(value)
        },
        gender: function (value) {
            return Validator.value(value)
        },
        hasCase : function (value){
            return Validator.value(value)
                .custom(() => {
                    if (this.type===2 && !this.residenceCountry.length && !this.spoken.length && !this.study.length && !this.time.length && !this.country.length && this.gender == null) {
                        return '조건을 선택해주세요.';
                    }
                })
            return value;
        },
        isAfterCurrentTime : function (value){
            const targetDate = new Date(this.reservationDate);
            const currentDate = new Date();
            return Validator.value(value)
                .custom(() => {
                    if (this.reservation === 1 &&targetDate < currentDate) {
                        return '발송 날짜 및 시간을 현재 이후로 설정해주세요.';
                    }
                })
            return value;
        },
    }
}
